import React from 'react';
import 'css/ViewListToolbar.css';

const ViewListToolbar = (props) => {
    return (
        <section className="view-list-toolbar">
            <div className="title-container">
                {props.image ? <div className="live-dot" /> : null}
                <div className="toolbar-title">{props.title}</div>
            </div>
            <div className="toolbar-link" onClick={props.onLinkClickHandler}>
                {props.link}
            </div>
        </section>
    );
};

export default ViewListToolbar;
